import React, { FC, useCallback } from 'react'

import { FORM_ELEMENTS } from '../types'

import * as SC from './styled'
import { CheckboxVariant } from './types'

export type Checkbox = {
  label: string
  id: string
}

export type CheckboxGroupProps = {
  className?: string
  legend?: string
  name?: string
  items?: Checkbox[]
  value?: string[]
  type?: FORM_ELEMENTS.CHECKBOX_GROUP
  onChange: (name?: string, values?: string[]) => void
  variant?: CheckboxVariant
}

const CheckboxGroup: FC<CheckboxGroupProps> = (props) => {
  const {
    className,
    items,
    legend,
    name,
    onChange,
    value,
    variant = CheckboxVariant.default,
  } = props

  const handleCheckboxChange = useCallback(
    (c: Checkbox) => {
      const outputValues = value?.includes(c.id)
        ? value.filter((i) => i !== c.id)
        : [...(value ?? []), c.id]

      onChange?.(name, outputValues)
    },
    [value, onChange, name]
  )

  return (
    <SC.Group className={className}>
      {name && <SC.Legend>{legend}</SC.Legend>}
      {items?.map((c) => (
        <SC.CheckboxWrapper
          checked={value?.includes(c?.id) ?? false}
          key={c?.id}
          $variant={variant}
        >
          <SC.Checkbox
            type="checkbox"
            id={`${name}-${c?.id}`}
            name={name}
            checked={value?.includes(c?.id) ?? false}
            onChange={() => handleCheckboxChange(c)}
          />
          {variant === CheckboxVariant.default && (
            <SC.CheckContainer>
              <SC.Check />
            </SC.CheckContainer>
          )}
          {variant === CheckboxVariant.target && (
            <SC.PlusContainer checked={value?.includes(c?.id) ?? false}>
              <SC.PlusIcon icon="plus" />
            </SC.PlusContainer>
          )}
          <SC.Label htmlFor={`${name}-${c?.id}`} $variant={variant}>
            {c?.label}
          </SC.Label>
        </SC.CheckboxWrapper>
      ))}
    </SC.Group>
  )
}

export default CheckboxGroup
